import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from './imports/muiImport';
import { alpha } from '@mui/system';

const GuidelinesModal = ({
  open = true,
  onOpen = () => { },
  onClose = () => { },
  payButtonClick = () => { },
  limit_transaction_heading = null,
  description = null,
  button_text_upi = null,
}) => {
  const theme = useTheme();

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="guidelines-modal-title"
        aria-describedby="guidelines-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            bottom: { xs: 0, sm: '50%' },
            transform: {
              xs: 'translateX(-50%)',
              sm: 'translate(-50%, 50%)',
            },
            width: {
              xs: '100%',
              sm: '90%',
              md: 500,
            },
            maxHeight: '90vh',
            overflowY: 'auto',
            bgcolor: 'background.paper',
            borderRadius: {
              xs: '28px 28px 0 0',
              sm: 4,
            },
            px: {
              xs: 3,
              sm: 5,
              md: 6,
            },
            py: {
              xs: 4,
              sm: 5,
            },
            textAlign: 'center',
            outline: 'none',
            boxSizing: 'border-box',
          }}
        >
          <IconButton
            onClick={onClose}
            aria-label="Close"
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,

              color: alpha(theme.palette.common.black, 1),
              backgroundColor: '#C9CDCF',
              borderRadius: 2,

              width: 36,
              height: 36,

              '&:hover': {
                color: alpha(theme.palette.common.white, 1),
                bgcolor: alpha(theme.palette.common.black, 1),
                boxShadow: 4,
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Box
            sx={{
              width: { xs: 110, sm: 150 },
              height: { xs: 110, sm: 150 },

              p: 1.5,
              mx: 'auto',
              mb: 3,
              borderRadius: '50%',
              bgcolor: 'rgb(75 205 243 / 15%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              component={'img'}
              src="/upi-guideline-image.png"
              sx={{
                width: '100%',
                height: 'auto',
              }}
            />
          </Box>

          <Typography
            id="guidelines-modal-title"
            variant="h5"
            fontWeight={700}
            sx={{
              fontSize: {
                xs: '1.35rem',
                sm: '1.6rem',
              },
              mb: 2,
            }}
          >
            {limit_transaction_heading }
          </Typography>

          <Typography
            id="guidelines-modal-description"
            variant="body1"
            sx={{
              maxWidth: 450,
              mx: 'auto',
              mb: 4,
              fontSize: {
                xs: '0.95rem',
                sm: '1.275rem',
              },
              lineHeight: 1.75,
              color: 'text.secondary',
            }}
          >
            {description}
          </Typography>

          <Button
            variant="contained"
            onClick={() => payButtonClick()}
            sx={{
              width: {
                xs: '100%',
                sm: 320,
              },
              backgroundColor: '#000',
              color: '#fff',
              minHeight: { xs: '55px', lg: '46px' },
              height: { xs: 44, lg: 48 },
              fontSize: { xs: '1.2rem', lg: '1.4rem' },
              fontWeight: 500,
              borderRadius: '999px',
              textTransform: 'none',
              px: 6,
              minWidth: { xs: '90%', sm: '360px' },
              maxWidth: '420px',
              mx: 'auto',
              '&:hover': {
                backgroundColor: '#000',
                boxShadow: 6,
              },
              '&.Mui-disabled': {
                backgroundColor: '#000',
                opacity: 0.6,
                color: '#fff',
              },
            }}
          >
            {button_text_upi}
          </Button>
        </Box>
      </Modal >
    </>
  );
};

export default GuidelinesModal;
